import {
  EMPTY_STEP_METADATA,
  IWizardStudentState,
  T_WIZARD_STUDENT_STEP,
  TStepConfiguration,
  TWizardStepComponentMultiEditable,
  WIZARD_STUDENT_STEPS,
  WizardStepComponentType
} from "../interfaces";
import { WizardStepWelcome } from "./Steps/WizardStepWelcome";
import { StepContainerWide } from "./styles";
import { WizardStepPersonalInfo } from "./Steps/WizardStepPersonalInfo";
import { WizardStepExpectations } from "./Steps/WizardStepExpectations";
import { WizardStepAboutMyself } from "./Steps/WizardStepAboutMyself";
import { WizardStepAvatar } from "./Steps/WizardStepAvatar";
import { WizardStepMatchExpectations } from "./Steps/WizardStepMatchExpectations";
import { WizardStepSearchPreferences } from "./Steps/WizardStepSearchPreferences";
import { WizardStepOverview } from "./Steps/WizardStepOverview";
import { STUDENT_WIZARD_FINISHED_ROUTE } from "../../../utils/constants";

export const WIZARD_STUDENT_DEFAULT_STATE: IWizardStudentState = {
  metadata: {
    started: false,
    finished: false,
    created_at: null,
    updated_at: null,
    most_recent_active_step: null
  },
  personal_info: null,
  expectations: {
    metadata: EMPTY_STEP_METADATA,
    past_experience: [],
    propose: [],
    study: ""
  },
  about_myself: {
    metadata: EMPTY_STEP_METADATA,
    spoken_languages: null,
    categorization: [],
    description: ""
  },
  avatar: null,
  match_expectations: {
    metadata: EMPTY_STEP_METADATA,
    ideal_match: [],
    match_characteristics: []
  },
  search_preferences: {
    metadata: {
      started: false,
      finished: false,
      created_at: null,
      updated_at: null
    },
    amount_looking_people: "myself",
    max_budget: 1000,
    min_area: 7,
    preferred_move_in: null,
    preferred_move_out: null,
    search_location_string: null
  }
};

export const WIZARD_STUDENT_STEPS_CONFIGURATION: {
  [key in T_WIZARD_STUDENT_STEP]?: TStepConfiguration<
    IWizardStudentState,
    T_WIZARD_STUDENT_STEP
  >;
} = {
  [WIZARD_STUDENT_STEPS.Welcome]: {
    component: WizardStepWelcome,
    container: StepContainerWide,
    type: WizardStepComponentType.Static
  },
  [WIZARD_STUDENT_STEPS.PersonalInfo]: {
    component: WizardStepPersonalInfo,
    type: WizardStepComponentType.Editable
  },
  [WIZARD_STUDENT_STEPS.Expectations]: {
    component: WizardStepExpectations,
    type: WizardStepComponentType.Editable
  },
  [WIZARD_STUDENT_STEPS.AboutMyself]: {
    component: WizardStepAboutMyself,
    type: WizardStepComponentType.Editable
  },
  [WIZARD_STUDENT_STEPS.Avatar]: {
    component: WizardStepAvatar,
    type: WizardStepComponentType.Editable
  },
  [WIZARD_STUDENT_STEPS.MatchExpectations]: {
    component: WizardStepMatchExpectations,
    type: WizardStepComponentType.Editable
  },
  [WIZARD_STUDENT_STEPS.SearchPreferences]: {
    component: WizardStepSearchPreferences,
    type: WizardStepComponentType.Editable
  },
  [WIZARD_STUDENT_STEPS.Overview]: {
    component: WizardStepOverview as TWizardStepComponentMultiEditable<
      IWizardStudentState,
      T_WIZARD_STUDENT_STEP
    >,
    type: WizardStepComponentType.MultiEditable,
    afterFinishRedirectUrl: STUDENT_WIZARD_FINISHED_ROUTE,
    nextButtonText: "buttonFinish"
  }
};

export const WIZARD_STUDENT_STEPS_ORDER: T_WIZARD_STUDENT_STEP[] = [
  WIZARD_STUDENT_STEPS.Welcome,
  WIZARD_STUDENT_STEPS.PersonalInfo,
  WIZARD_STUDENT_STEPS.Expectations,
  WIZARD_STUDENT_STEPS.AboutMyself,
  WIZARD_STUDENT_STEPS.Avatar,
  WIZARD_STUDENT_STEPS.MatchExpectations,
  WIZARD_STUDENT_STEPS.SearchPreferences,
  WIZARD_STUDENT_STEPS.Overview
];
